// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { userSchema } from '@/authentication/api/types';

const currentUserResponseSchema = z
  .object({ data: userSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, user: data }));

export type CurrentUserResponse = z.infer<typeof currentUserResponseSchema>;

/**
 * Requests the current user from the remote API.
 */
export async function getCurrentUser(): Promise<CurrentUserResponse> {
  const response = await api.get('/meta/current-user');

  return parseResponse(currentUserResponseSchema, response.data, {
    schemaName: 'CurrentUser',
    endpoint: '/meta/current-user',
  });
}
